import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { FilesService } from 'src/app/core/services/files.service';
import { UserService } from 'src/app/core/services/user.service';
import { CasoTareaService, Files } from 'src/app/services/casos_tareas.service';
import { CaseFile } from '../../../interface/CaseFile.interface';
import { CaseFileService } from '../../../services/case-file.service';
import { ConfirmDeleteComponent } from '../case-files/confirm-delete/confirm-delete.component';
import { TaskCaseService } from '../../../services/taskCase.service';
enum Tabs {
  task = 'Tareas',
  iCase = 'Caso',
}
@Component({
  selector: 'case-files-ras',
  templateUrl: './case-files-ras.component.html',
  styleUrls: ['./case-files-ras.component.scss'],
})
export class CaseFilesRasComponent implements OnInit {
  public Tabs = Tabs;
  idCaso;
  files: CaseFile[] = [];
  selected: Tabs = Tabs.iCase;

  constructor(
    private readonly caseFileService: CaseFileService,
    private readonly route: ActivatedRoute,
    private readonly casoTareaService: CasoTareaService,
    private readonly dialog: MatDialog,
    private readonly filesService: FilesService,
    private readonly userService: UserService,
    private readonly taskCaseService: TaskCaseService
  ) {
    this.idCaso = route.snapshot.paramMap.get('id');
    this.getFiles();
    this.getData();
  }

  get canEdit() {
    return this.userService.permissions.editCases;
  }

  getFiles() {
    this.caseFileService.getAllCaseFile(this.idCaso).subscribe({
      next: (files) => {
        this.files = files;
      },
    });
  }

  ngOnInit() {}
  tasks;
  getData(filters = {}) {
    this.taskCaseService.getTaskAndFiles(this.idCaso).subscribe((data) => {
      this.tasks = data;
    });
  }
  deleteFileTask(x) {
    this.getData();
  }
  delete(idFile: string) {
    this.dialog
      .open(ConfirmDeleteComponent, {
        width: '400px',
        height: '155px',
      })
      .afterClosed()
      .subscribe({
        next: (response) => {
          if (response) {
            this.caseFileService.deleteCaseFile(idFile).subscribe({
              next: () => {
                this.getFiles();
              },
            });
          }
        },
      });
  }

  // async uploadFile(file: any) {
  //   const newfile = await this._fileUpload.upload(file).toPromise();
  //   let fileToUpload: Files = {
  //     file_path: newfile.filename,
  //     filename: file.name,
  //   };
  //   this.casoTareaService.addFileToCase(this.idCaso, fileToUpload).subscribe({
  //     next: (files) => {
  //       this.files = files;
  //     },
  //   });
  // }

  addFile() {
    const input = document.createElement('input');
    input.type = 'file';

    input.click();
    input.onchange = (ev: any) => {
      const file: File = ev.target.files[0];
      const formData = new FormData();
      formData.append('file', file);
      this.filesService.upload(formData).subscribe({
        next: (url) => {
          const newFile = {
            url,
            name: file.name,
            case: this.idCaso,
          };
          this.caseFileService
            .createCaseFile(newFile)
            .subscribe((file: any) => {
              this.files.push(file);
            });
        },
      });
    };
  }
}
